---
title: "Pakete empfangen"
slug: scanning-a-package
description: "Schritt-für-Schritt-Anleitung zum Empfangen eines Pakets per Kamera-Scan oder manueller GRAI-Eingabe."
keywords:
  - empfangen
  - scannen
  - Paket
  - GRAI
  - Scan
  - Kamera
  - Letzte Aktivität
---

## Voraussetzungen

- Rolle: Scanner, Manager oder Company Admin
- Mindestens ein interner Standort muss Ihrem Konto zugewiesen sein
- Das Paket muss eine gültige GRAI-Kennung tragen

## Schritt für Schritt

1. Navigieren Sie im oberen Menü zu **Empfangen**.
2. Wählen Sie Ihren aktuellen Standort aus dem Dropdown **Scan-Standort**.
3. Richten Sie die Kamera auf den QR-Code des Pakets. Der Scan startet automatisch, sobald der Code erkannt wird.
   - Alternativ: Klicken Sie auf **Paket-ID eingeben**, um die GRAI manuell einzugeben oder einzufügen.
4. Fügen Sie bei Bedarf unter **Zusätzliche Informationen** eine kurze Notiz zum Paket hinzu (z. B. Zustand bei Annahme).
5. Klicken Sie auf **Scan erfassen**, um den Empfang zu bestätigen.
6. Der Scan wird sofort unter **Letzte Aktivität** im Scanner-Bereich angezeigt.

## Wenn es schiefgeht

- **"Paket nicht gefunden"** — Die GRAI ist möglicherweise noch nicht registriert. Nutzen Sie die Funktion **Als neues Paket registrieren**, um es anzulegen.
- **"Ungültiges GRAI-Format"** — Prüfen Sie, ob der eingegebene Code vollständig ist (34 Zeichen).
- **"Sie sind nicht berechtigt, an diesem Standort zu scannen"** — Ihre Rolle erlaubt keinen Scan an diesem Standort. Wenden Sie sich an Ihren Company Admin.
- **Kamera nicht verfügbar** — Prüfen Sie, ob Ihr Browser Kamerazugriff hat. Verwenden Sie alternativ die manuelle Eingabe.
- **Offline-Modus** — Bei fehlender Verbindung werden Scans gespeichert und nach Verbindungswiederherstellung automatisch synchronisiert.
- Kontaktieren Sie uns: support@heycircle.com oder nutzen Sie die Feedback-Schaltfläche unten rechts auf dem Bildschirm.

## Verwandte Artikel

- [Pakete senden](/app/help?article=sending-a-package)
- [Defekt melden](/app/help?article=reporting-a-defect)
- [Analysen lesen](/app/help?article=viewing-analytics)
